var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('application-page',{staticClass:"application"},[_c('h1',{staticClass:"application__title",attrs:{"slot":"title"},slot:"title"},[_vm._v(" "+_vm._s(_vm.$t('REGISTRATION_SUMMARY.TITLE'))+" ")]),_c('div',{staticClass:"application__container"},[_c('summary-form',{attrs:{"previous-page":_vm.errorPage}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }